export const environment = {
   production: false,
   zdoxCustomerId: 'e4YPZo2UYu8KEDptw7gIw75hru1uK8bxn-SGYtob',
   //|
   //| If PDFTron key is expired, let the key be an empty string to continue testing
   //| while waiting for a new key to be issued.
   //|
   //|    pdfTronKey: ''
   //|
   //| When no key is provided, PDFTron will run in demo mode
   //|
   //| In Demo mode, there'll be 'PDFTRON' watermarks on every documents and
   //| some features may be limited.
   //|______________________________________________________________________________
   //|
   //| If you have "Bad License Key" ERROR, this post may be of help:
   //| https://community.pdftron.com/t/license-key-exception/3376
   //|______________________________________________________________________________
   //|
   //| If you still have a problem, I suggest we send an email to PDFTron asap.
   //|______________________________________________________________________________
   pdfTronKey: 'Ginkgo Soft Co Ltd:OEM:zDox::B+:AMS(20260608):5A549B3CE60F8B5A6048B253187F610F600DE2566D8DEF05333C5030DE5AEAB6F5C7'
};
